{
  "sitemaps": {
    "title": "Sitemaps",
    "page_content": "Sitemaps ermöglichen es Ihnen, detaillierte CAD-Zeichnungen von Veranstaltungsorten/Standorten in die Karte zu integrieren. Unten können Sie Sitemaps und CAD-Zeichnungen hinzufügen und verwalten.",
    "no_sitemaps_title": "Es ist ein bisschen leer hier...",
    "no_sitemaps_body_1": "Derzeit gibt es keine wichtigen Standorte oder Sitemaps! Klicken Sie auf ",
    "no_sitemaps_body_2": " Schaltfläche, um beliebig viele Standorte hinzuzufügen",
    "add_sitemap": "Sitemap hinzufügen",
    "create_sitemap_comming_soon_message": "Der Selbst-Upload von CAD-Zeichnungen ist in Kürze verfügbar. In der Zwischenzeit kann unser Support-Team Ihre CADs für Sie hochladen.",
    "click_to_open_sitemap_options": "Klicken Sie, um die Sitemap-Optionen zu öffnen",
    "edit_sitemap": "Sitemap bearbeiten",
    "delete_sitemap": "Sitemap löschen"
  },
  "user_settings": "Einstellungen des Benutzers",
  "help": "Hilfe",
  "help_menu": {
    "title": "Hilfe und Ressourcen",
    "getting_started": "Erste Schritte mit Iventis",
    "knowledge_base": "Iventis Wissensdatenbank",
    "support": "Unterstützung",
    "about": "Über Iventis"
  },
  "sso": {
    "title": "SSO-Konfiguration",
    "page_content": "Hier können Sie die SSO-Konfiguration für das Projekt bearbeiten",
    "response_signing_certificate": "Zertifikat zum Signieren der Antwort",
    "meta_data_location": "URL der Metadaten des Identitätsanbieters",
    "identity_provider": "Entitäts-ID des Identitätsanbieters",
    "saved": "Die SSO-Konfiguration wurde erfolgreich gespeichert",
    "setup_description": "Wenn Sie SSO mit Ihrem Identitätsanbieter einrichten, müssen Sie SAML auswählen und die folgenden Eigenschaften eingeben",
    "entity_id": "Entitäts-ID",
    "rely_url": "Antwort-URL",
    "signon_url": "URL für die Anmeldung",
    "sso_enabled": "SSO aktiviert",
    "enable_confirmation": "Sind Sie sicher, dass Sie SSO für dieses Projekt aktivieren möchten?",
    "enable_confirmation_warning": "Stellen Sie sicher, dass SSO ordnungsgemäß konfiguriert ist, bevor Sie es aktivieren, um zu verhindern, dass Benutzer vom Projekt ausgeschlossen werden",
    "disable_confirmation": "Möchten Sie SSO wirklich für dieses Projekt deaktivieren?",
    "disable_confirmation_warning": "Bei der Deaktivierung von SSO müssen alle Benutzer, die derzeit auf SSO angewiesen sind, ein Passwort festlegen. Sie erhalten eine E-Mail mit Anweisungen zur Erstellung ihres Passworts, um weiterhin auf das Projekt zugreifen zu können.",
    "disable_confirmation_warning2": "Sobald SSO deaktiviert ist, muss der SSO-Zugriff für jeden Benutzer manuell erneut aktiviert werden, um es erneut zu aktivieren."
  },
  "projectCustomisation": {
    "projectNameWarning": "Wenn Sie den Projektnamen ändern, ändert sich Folgendes:",
    "projectNameWarningSsoKey": "Also:",
    "projectNameWarningSsoValue": "Konfigurations-URLs (falls aktiviert)",
    "projectNameWarningUrlKey": "Projekt-URL:"
  },
  "projectRolePermissions": {
    "projectAdministratorsSubMenu": "Projekt-Administratoren",
    "projectAdministratorsTitle": "Projektadministratoren",
    "projectAdminRoleDescription": "Hier können Sie Projektadministratoren hinzufügen oder entfernen. Diese Benutzer haben Zugriff auf alle Projektdaten, Einstellungen und Berechtigungen und können diese bearbeiten.",
    "addAdmin": "Benutzer hinzufügen",
    "addProjectAdmin": "Fügen Sie einen Projektadministrator hinzu",
    "removeAdmin": "Admin-Status entfernen",
    "removeAdminConfirm": "Diese Person wird kein Projektadministrator mehr sein. Möchten Sie fortfahren?",
    "removeYourselfAdminConfirm": "Sie verlieren den Zugriff auf den Projektadministrator und können ihn nicht erneut hinzufügen. Möchten Sie fortfahren?",
    "projectAdminsSelectedConfirmButton": "Ausgewählte hinzufügen",
    "addAdminsToast": "Admins wurden erfolgreich hinzugefügt",
    "removeAdminToast": "Admin wurde erfolgreich entfernt"
  }
}